import { Injectable } from '@angular/core'
import { datadogLogs } from '@datadog/browser-logs'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  info(message: string, context?: object) {
    if (environment.dataDogConfigLogs) datadogLogs.logger.info(message, context)
  }

  error(message: string, context?: object) {
    if (environment.dataDogConfigLogs) datadogLogs.logger.error(message, context)
  }
}
